/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface AuditExportResponse {
  export_id: string;
  status?: string | null;
  url?: string | null;
  expires_at?: string | null;
  error?: string | null;
  error_code?: string | null;
}
